import { PropsWithChildren } from 'react';
import { Box, FelaCSS } from '@bridebook/ui';
import mergeStyles from '../../../../fela-utils/merge-styles';
import componentStyles from './carousel-heading.style';

export interface ICarouselHeadingProps extends PropsWithChildren {
  style?: FelaCSS;
  noPadding?: boolean;
}

const CarouselHeading = ({ noPadding, children, style = {} }: ICarouselHeadingProps) => {
  const styles = componentStyles({ noPadding });
  return (
    <Box style={mergeStyles([styles.wrapper, style])} data-name="carousel-heading">
      {children}
    </Box>
  );
};

export default CarouselHeading;
